import { render, staticRenderFns } from "./GetPurchaseInvoicesByDateInterval.vue?vue&type=template&id=de72cb34&scoped=true&"
import script from "./GetPurchaseInvoicesByDateInterval.vue?vue&type=script&lang=js&"
export * from "./GetPurchaseInvoicesByDateInterval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de72cb34",
  null
  
)

export default component.exports